export default {
  updateSpecialInstructions: (visitId: number) =>
    `api/Visits/${visitId}/specialInstructions`,
  getTranslatedLabels: (orderGUID: string, languageCode: string) =>
    `api/Clients/metadata/${orderGUID}/labels/${languageCode}`,
  getAuthType: (orderGUID: string) =>
    `api/Users/authenticationType/${orderGUID}`,
  authenticate: (orderGUID: string) => `api/Users/authenticate/${orderGUID}`,
  getConfig: (orderGUID: string) =>
    `api/Clients/metadata/${orderGUID}/settings`,
  getStyles: (orderGUID: string) => `api/Clients/metadata/${orderGUID}/theme`,
  getBrandLogo: (orderGUID: string) =>
    `api/Clients/metadata/${orderGUID}/assets/images/logo`,
  getFooterLinks: (orderGUID: string): string =>
    `api/Clients/metadata/${orderGUID}/footerlink`,
  getOrderHeaderDetails: () => `api/Orders/orderHeaderDetail`,
  getAllVisits: () => `api/Visits`,
  getBookingDates: () => `api/Orders/bookingWindows`,
  bookVisitDate: () => `api/Visits`,
}
